<template>
<v-app class="ma-0 pa-0" id="app">
     <v-layout class="upper-row" row wrap>
      <v-flex xs2 sm2>
      </v-flex>
      <v-flex xs8 sm8>
     <v-card
    class="mx-auto"
    outlined
  >
   <v-form class="pa-8">


                      <v-text-field
                        v-model="formInput.email"
                        label="Email"
                        name="Email"
                         :error-messages="emailErrors"
                        prepend-icon="mdi-email"
                        type="email"
                      ></v-text-field>

                  <v-text-field
                    id="password"
                    label="Password"
                    name="password"
                    v-model="formInput.password"
                    :error-messages="passErrors"
                    prepend-icon="mdi-lock-open"
                    type="password"
                  ></v-text-field>

                </v-form>
                <v-card-actions>
        <v-btn @click="login()" v-if="!loggedIn" class="md-raised md-primary CTA CTA--Main">
            <span class="buttonText">Anmelden</span>
          </v-btn>
      </v-card-actions>
      <v-progress-linear v-if="sending"
            indeterminate
            rounded
            height="6"
          ></v-progress-linear>
     </v-card>
     </v-flex>
      <v-flex xs2 sm2>
      </v-flex>
     </v-layout>
</v-app>
                
</template>
<script>
import auth from "../auth";
import { validationMixin } from 'vuelidate'
import { required, minLength, email, sameAs } from 'vuelidate/lib/validators'

export default {
  name: "Signin",
  validations: {
    formInput: {
      email: {
        required,
        email
      },
      password: {
        required,
        minLength: minLength(8)
      }
    }
  },
  data() {
    return {
      error: false,
      formInput: {
        email: '',
        password: '',
      },
      loggedIn: false,
      sending: false
    };
  }, 
  computed: {
      emailErrors () {
        const errors = []
        if (!this.$v.formInput.email.$dirty) return errors
        !this.$v.formInput.email.email && errors.push('Keine gültige Email-Adresse')
        !this.$v.formInput.email.required && errors.push('Email ist ein Pflichfeld')
        return errors
      },
      passErrors () {
        const errors = []
        if (!this.$v.formInput.password.$dirty) return errors
        !this.$v.formInput.repassword.required && errors.push('Passwort ist ein Pflichfeld')
        return errors
      }
      },
  methods: {
    clearForm() {
      this.$v.$reset();
      this.formInput.email = null;
      this.formInput.password = null;
    },
    login() {
      this.sending = true;
      auth.login(this.formInput.email, this.formInput.password, loggedIn => {
        if (!loggedIn) {
          console.log("fail")
          this.error = true;
          window.setTimeout(() => {
            this.error = false;
          }, 3000);
          this.sending = false;
        } else {
          this.$router.push({ name: "enterdetails" });
          this.sending = false;
        }
      });
    }}
};

</script>